<template>
  <div>
    <div id="aaa"></div>
    <van-nav-bar fixed title="订单明细" left-arrow @click-left="onClickLeft" />
    <van-field label="订单号" :value="orderNum" disabled />
    <!-- <div style="font-size:0.5rem;text-align:center">{{orderNum}}</div> -->
    <!-- <van-cell :value="orderNum" /> -->
    <van-cell-group v-if ="orderDetail[0]">
      <van-cell
        v-for="(item, index) in orderDetail"
        :key="index"
        :title="item.purchase_order_num"
        clickable
        @click="selectedOrderNum(item)"
      >
        <van-row>
          <van-col span="6">型号</van-col>
          <van-col span="18">{{ item.model_name }}</van-col>
        </van-row>
        <van-row>
          <van-col span="6">采购数量</van-col>
          <van-col span="18">{{ item.quantity }}</van-col>
        </van-row>
      </van-cell>
    </van-cell-group>

    <van-empty v-else description="暂无信息" />
  </div>
</template>

<script>
import {
  NavBar,
  Cell,
  Col,
  Row,
  CellGroup,
  Empty,
} from "vant";
export default {
  components: {
    [NavBar.name]: NavBar,
    [Cell.name]: Cell,
    [Col.name]: Col,
    [Row.name]: Row,
    [Empty.name]: Empty,
    [CellGroup.name]: CellGroup,
  },
  data() {
    return {
      message:"",
      orderNum: "",
      orderDetail: [],
      confirmDetail : [],
      refer:"",
      mainid:"",
    };
  },
  methods: {
    onClickLeft() {
      let params = {
        ordernum: this.orderNum,
        confirmDetail: this.confirmDetail,
        message:this.message,
      }
      if (this.refer == "salesreturndetail") {
        params.mainid = this.mainid;
      }
      this.$router.push({
        name: this.refer,
        params,
      });
      // this.$router.go(-1);
    },
    selectedOrderNum(item) {
      let params = {
        ordernum: this.orderNum,
        confirmDetail: this.confirmDetail,
        message:this.message,
      }
      if (this.refer == "salesreturndetail") {
        item.old_quantity = item.quantity;
        item.quantity = "";
        item.order_detail_id = item.detail_id;
        item.return_detail_id = "";
        params.mainid = this.mainid;
      }
      this.confirmDetail.push(item);
      this.$router.push({
        name: this.refer,
        params,
      });
    },
  },
  created() {
    this.orderDetail = this.$route.params.orderDetail;
    //window.console.log(this.orderDetail);
    this.orderNum = this.$route.params.orderNum;
    this.confirmDetail = this.$route.params.confirmDetail;
    this.message = this.$route.params.message;
    this.refer = this.$route.params.refer;
    this.mainid = this.$route.params.mainid;
  },
};
</script>

<style scoped lang="less">
.van-nav-bar {
  background: #ffffff;
  color: #323233;
  font-weight: bold;
}
.van-nav-bar__title {
  font-weight: 800;
  color: #323233;
}
#aaa {
  width: 100vw;
  height: 46px;
}
</style>